module.exports = __webpack_public_path__ + "img/67e060c.jpg";